// import parser from 'intl-messageformat-parser';

const selectAll = "Select all that apply";
const amountToBorrow = "Amount";
const loanTiming = "Months from now";
const loanTimingOptions = {
  now: "Immediate",
  three: "3",
  six: "6",
  nine: "9",
  twelve: "12",
};
const loanAccess = "When will you access your money?";
const wantsToBorrow = "Do you wish to borrow?";
const upFront = "All at once";
const overTime = "Over time";
const yes = "Yes";
const no = "No";

export default {
  /**
   * ============================
   * GENERAL MESSAGES
   * ============================
   */
  "landing.title":
    "Find the right ANBTX accounts and services for your business needs",
  "landing.message": "...in less than five minutes",

  summaryPage: "Your Recommended Business Banking Solutions",

  "features.title" : "Why best for me",

  otherAccounts: " ",
  "otherAccounts.options": " ",
  // 'otherAccounts': "Why is best for my business?",
  // 'otherAccounts.options': "<li><span>Personal Loan <img alt='New Window' src='/classpath/assets/images/icons/open-window.svg'/></span></li><li><span>Home Equity Loan or Line of Credit <img alt='New Window' src='/classpath/assets/images/icons/open-window.svg'/></span></li><li><span>Financial Planning <img alt='New Window' src='/classpath/assets/images/icons/open-window.svg'/></span></li><li><span>FDIC-insured CDs and IRAs <img alt='New Window' src='/classpath/assets/images/icons/open-window.svg'/></span></li><li><span>Asset/Portfolio Management <img alt='New Window' src='/classpath/assets/images/icons/open-window.svg'/></span></li><li><span>Homeowners Insurance <img alt='New Window' src='/classpath/assets/images/icons/open-window.svg'/></span></li><li><span>Personal Automobile Insurance <img alt='New Window' src='/classpath/assets/images/icons/open-window.svg'/></span></li><li><span>Individual Life Insurance <img alt='New Window' src='/classpath/assets/images/icons/open-window.svg'/></span></li>",

  detailsPage: "Business Banking Solutions for Growth",
  "detailsPage.message":
    '<strong>Congratulations!</strong> Based on your responses, here is the solution we recommend that meets your personal banking needs. Using this information, a banking specialist from <strong>ANBTX</strong> can help you move toward your financial goals today.<br><br>To connect with a banking specialist, call us directly at <a href="tel:800-837-6584">800.837.6584</a>, <strong>Monday-Friday 7am-7pm, and Saturday 9am-1pm</strong>, or print out your recommendation and take it to your nearest banking center.',

  "answersList.title": "Your Answers",

  /**
   * ============================
   * QUESTION MESSAGES
   * ============================
   */

  isCustomer: "Are you a current ANBTX customer?",
  "isCustomer.personal": "Yes, personal banking only",
  "isCustomer.business": "Yes, business banking only",
  "isCustomer.both": "Yes, both personal and business",
  "isCustomer.no": "Not yet",

  checkingStyle: "Find your checking style",
  gettingKnow: "Understanding Your Business",
  "business.message": "Helping business for more than 140 years.",


  industryGroup: "Which industry describes your business?",
  "industryGroup.agriculture": "Agriculture, Forestry & Fishing",
  "industryGroup.construction": "Construction",
  "industryGroup.finance": "Finance/Insurance",
  "industryGroup.foodServices": "Food Services",
  "industryGroup.healthCare": "Healthcare",
  "industryGroup.hospitality": "Hospitality",
  "industryGroup.informationTechnology": "Information Technology",
  "industryGroup.legal": "Legal",
  "industryGroup.manufacturing": "Manufacturing",
  "industryGroup.mining": "Mining/Oil & Gas",
  "industryGroup.personalServices": "Personal Services",
  "industryGroup.professionalServices": "Professional Services",
  "industryGroup.publicAdministration": "Public Administration",
  "industryGroup.publicUtilities": "Public Utilities",
  "industryGroup.publishing": "Publishing & Broadcasting",
  "industryGroup.realEstate": "Real Estate",
  "industryGroup.religious": "Religious/Civic Organization",
  "industryGroup.repair": "Repair",
  "industryGroup.retail": "Retail Trade",
  "industryGroup.scienceEngineering": "Science/Engineering",
  "industryGroup.telecommunications": "Telecommunications",
  "industryGroup.transportation": "Transportation/Warehousing",
  "industryGroup.utilities": "Utilities",
  "industryGroup.wholesaleTrade": "Wholesale Trade",
  "industryGroup.other": "Other",

  businessType: "What is your business structure?",
  "businessType.soleProprietor": "Sole Proprietor",
  "businessType.sCorporation": "S Corporation",
  "businessType.cCorporation": "C Corporation",
  "businessType.llc": "Limited Liability Corporation (LLC)",
  "businessType.llp": "Limited Liability Partnership (LLP)",
  "businessType.trust": "Trust",
  "businessType.association": "Association/Organization",
  "businessType.other": "Other",

  employmentPosition: "What is your role in the business?",
  "employmentPosition.owner": "Owner",
  "employmentPosition.employee": "Employee",
  "employmentPosition.other": "Other",

  isNonProfit: "Are you classified as a Non-Profit? ",
  //"isNonProfit.icon": "<img src='/classpath/assets/images/blueStar.svg' />",
  "isNonProfit.true": "Yes",
  "isNonProfit.false": "No",

  yearsInBusiness: "How many years have you been in business?",
  numberOfEmployees: "Number of employees (including you)",
  annualRevenue: "What is your annual revenue?",

  businessGoods: 'How do you transact business?',
  'businessGoods.subtext': 'Choose all that apply',
  'businessGoods.online': 'Online',
  'businessGoods.office': 'Office / Storefront',
  'businessGoods.field': 'Offsite / In the field',
  'businessGoods.phone': 'Phone',
  'businessGoods.wholesale': 'Wholesale',
  'businessGoods.other': 'Other',

  "teamLocation.message": "Nearly 30 convenient branches across DFW.",
  teamLocation: "Where is your business located?",
  zipCode: "Zip Code",
  // "zipCode.icon":"<img src='/classpath/assets/images/icons/location.svg' />",

  monthlyReceiveTitle: "Monthly Payments You Receive from Customers",
  "monthlyReceiveTitle.subtext":
    "How many of each transaction type do you receive per month?",
  numberOfChecksReceived: "Checks",
  numberOfAchCredits: "Electronic (ACH)",
  numberOfWireTransfersIncoming: "Wire Transfers",
  numberOfCreditCardTransactions: "Debit/Credit Cards",
  numberOfPaymentsReceived: "Total",
  monthlyCashReceiveTitle: "Monthly Cash You Receive from Customers",
  monthlyCashReceived: "Cash Amount ($)",
  "simplifying.message": "Business Solutions to help your money work for you",
  "simplifying.icon": "/classpath/assets/images/icons/money-management.svg",
  simplifyingMoney: "Simplifying Your Money Management",
  "simplifyingMoney.subtext": "How many in-person deposits do you make per month?",
  numberOfDeposits: "# Deposits",

  wantAcceptCreditCards:
    "Would you like to accept credit/debit card payments from your customers?",
  "wantAcceptCreditCards.creditCard": "Yes",
  "wantAcceptCreditCards.no": "No",

  "monthlyPaymentsMake.message":
    "Treasury Management options tailored for you.",

  monthlyPaymentsMadeTitle: "Monthly Payments You Make to Others",
  "monthlyPaymentsMadeTitle.subtext":
    "How many of each transaction types do you make per month?",
  transactionsPerMonth:
    "How many of each transaction types do you make per month?",
  numberOfChecksWritten: "Checks",
  numberOfAchDebits: "Electronic (ACHs)",
  numberOfBillsPaidOnline: "Online Bills",
  numberOfWireTransfersOutgoing: "Wire Transfers",
  numberOfCreditCardPayments: "Card (Credit/Debit)",
  totalPaymentsOutgoing: "Total Payments",

  cashBalancesTitle:
    "On average, how much would you keep in the following accounts?",
  "cashBalances.message": "Treasury Management options tailored for you.",

  checkingBalance: "Checking",
  otherBalance: "Savings/Money Market/CD",
  combinedDepositBalance: "Total ($)",

  "streamlining.message": "Loans decisioned locally, by Texas bankers.",
  streamliningCash: "Streamlining Your Cash Flow",

  foreseeLoanTitle: "Do you foresee the need for a loan in the next 12 months?",
  // 'foresee.icon': "<img alt='Cash Flow Icon' src='/classpath/assets/images/icons/cash-flow.svg' />" ,
  foreseeLoan: " ",
  "foreseeLoan.false": "No",
  "foreseeLoan.true": "Yes",
  wantBusinessRetirementPlan: "Are you interested in a free consultation about your retirement plan?",
  "wantBusinessRetirementPlan.true": "Yes",
  "wantBusinessRetirementPlan.false": "No, thank you",
  businessRetirementPlans: "Do you currently have a retirement plan in place for your employees?",
  "businessRetirementPlans.yes": "Yes",
  "businessRetirementPlans.no": "No, not interested",
  "businessRetirementPlans.discuss": "No, but would like to discuss",

  "growth.message": "Committed to North Texas. Committed to your success.",
  growing: "Growing Your Business",

  businessGoal: "What is the long term strategy for your business?",
  "businessGoal.expandMarkets": "Expand to new markets",
  "businessGoal.diversify": "Diversify with new products/services",
  "businessGoal.transitionOwnership": "Transition business to heirs",
  "businessGoal.sellBusiness": "Sell business",
  "businessGoal.statusQuo": "Maintain status quo",
  "businessGoal.notSure": "Not Sure",

  "protecting.message": "Your Bank. For Business and Life.",
  protectingBusiness: "Protecting Your Business",
  riskControlConcern: "Do you have fraud concerns?",
  "riskControlConcern.subtext": "Choose all that apply",
  "riskControlConcern.checkFraud": "Check Fraud",
  "riskControlConcern.checkFraud.icon":
    "/classpath/assets/images/icons/check.svg",
  "riskControlConcern.electronicFraud": "Electronic Fraud",
  "riskControlConcern.electronicFraud.icon":
    "/classpath/assets/images/icons/fraud.svg",
  "riskControlConcern.employeeFraud": "Employee Fraud",
  "riskControlConcern.employeeFraud.icon":
    "/classpath/assets/images/icons/employee.svg",
  "riskControlConcern.notFraud": "No, not concerned",
  "riskControlConcern.notFraud.icon": "/classpath/assets/images/icons/not.svg",

  relationshipUs: "Your relationship with us",
  "relationship.message": "Nearly 30 convenient branches across DFW.",

  howManyEmpl: "How many employees does your business have?",

  undefined: "Undefined",

  "loans.message": "Loans decisioned locally, by Texas bankers.",
  // 'loans.icon': '/classpath/assets/images/icons/streamlining.svg',
  addLoans: "Add loan(s)",
  "addLoans.false": "No",
  "addLoans.true": "Yes",

  foreseeLoans: "What loans do you foresee in the next 12 months?",

  goalsQuestionGroup:
    "Preparing for your goals is critical for achieving financial success.  Tell us what your current goals are:",
  "goalsQuestionGroup.subtext": "Add your financial goals below.",
  "loanPurpose.cardBuilder.removeCard": '<i class="fa fa-times-circle-o"></i>',
  "loanPurpose.cardBuilder.editCard":
    '<i class="fa fa-edit"></i>',
  "loanPurpose.cardBuilder.addCard":
    '<i class="fa fa-plus-circle"></i> <span>Add Loan</span>',
  "loanPurpose.cardBuilder.modal.title": "Select a Loan",
  loanPurpose: "Select your loan:",

  "loanPurpose.equipmentVehicles": 'Vehicles / Equipment',
  "loanPurpose.equipmentVehicles.icon": 'car',
  "loanPurpose.equipmentVehicles.cardLabel":
    '<img src="/classpath/assets/images/icons/car.svg" /><span>Vehicles / Equipment</span>',

  "loanPurpose.commercialRealEstate": "Real Estate",
  "loanPurpose.commercialRealEstate.icon": "real-estate",
  "loanPurpose.commercialRealEstate.cardLabel":
    '<img src="/classpath/assets/images/icons/real-state.svg" /><span>Real Estate</span>',

  "loanPurpose.inventoryWorkingCapital": "Working Capital",
  "loanPurpose.inventoryWorkingCapital.icon": "working-capital",
  "loanPurpose.inventoryWorkingCapital.cardLabel":
    '<img src="/classpath/assets/images/icons/working-capital.svg" /><span>Working Capital</span>',

  "loanPurpose.acquisitionLoan": "Business / Office Equipment",
  "loanPurpose.acquisitionLoan.icon": "acquisition",
  "loanPurpose.acquisitionLoan.cardLabel":
    '<img src="/classpath/assets/images/icons/acquisition.svg" /><span>Business / Office Equipment</span>',

  "loanPurpose.homeImprovementGoal": "Home Improvement",
  "loanPurpose.homeImprovementGoal.icon": "trophy-calculator",
  "loanPurpose.homeImprovementGoal.cardLabel":
    '<i class="fa fa-check"></i><span>Home Improvement</span>',
  "loanPurpose.secondacquisitionLoan": "Second Home",
  "loanPurpose.secondacquisitionLoan.icon": "trophy-calculator",
  "loanPurpose.secondacquisitionLoan.cardLabel":
    '<i class="fa fa-building"></i><span>Second Home</span>',
  "loanPurpose.retirementGoal": "Retirement",
  "loanPurpose.retirementGoal.icon": "trophy-calculator",
  "loanPurpose.retirementGoal.cardLabel":
    '<i class="fa fa-star"></i><span>Retirement</span>',
  "loanPurpose.majorPurchaseGoal": "Major Purchase",
  "loanPurpose.majorPurchaseGoal.icon": "trophy-calculator",
  "loanPurpose.majorPurchaseGoal.cardLabel":
    '<i class="fa fa-money"></i><span>Major Purchase</span>',
  "loanPurpose.lifeEventGoal": "Life Event",
  "loanPurpose.lifeEventGoal.icon": "trophy-calculator",
  "loanPurpose.lifeEventGoal.cardLabel":
    '<i class="fa fa-users"></i><span>Life Event</span>',
  "loanPurpose.otherGoal": "Other",
  "loanPurpose.otherGoal.icon": "trophy-calculator",
  "loanPurpose.otherGoal.cardLabel":
    '<i class="fa fa-question-circle-o"></i><span>Other</span>',

  "equipmentVehicles.cardBuilder.title": "Vehicles / Equipment",
  // 'equipmentVehicles.cardBuilder.body': '<img src="/classpath/assets/images/icons/car.svg" />',
  equipmentVehiclesAmount: "Amount",

  "details.equipmentVehiclesAmount": `Goals: Vehicles / Equipment | ${amountToBorrow}`,
  equipmentVehiclesTiming: "Months from now",
  "equipmentVehiclesTiming.1": loanTimingOptions.now,
  "equipmentVehiclesTiming.3": loanTimingOptions.three,
  "equipmentVehiclesTiming.6": loanTimingOptions.six,
  "equipmentVehiclesTiming.9": loanTimingOptions.nine,
  "equipmentVehiclesTiming.12": loanTimingOptions.twelve,
  "details.equipmentVehiclesTiming": `Goals: Vehicles / Equipment | ${loanTiming}`,
  equipmentVehiclesAccess: "When will you access your money?",
  "equipmentVehiclesAccess.upFront": upFront,
  "equipmentVehiclesAccess.overTime": overTime,
  "details.equipmentVehiclesAccess": `Goals: Vehicles / Equipment | ${loanAccess}`,
  equipmentVehiclesWantsToBorrow: "Do you wish to borrow?",
  "equipmentVehiclesWantsToBorrow.true": yes,
  "equipmentVehiclesWantsToBorrow.false": no,
  "details.equipmentVehiclesWantsToBorrow": `Goals: Vehicles / Equipment | ${wantsToBorrow}`,

  "commercialRealEstate.cardBuilder.title": "Real Estate",
  "commercialRealEstate.cardBuilder.body":
    '<i class="bmo-icon personal-wallet"></i>',
  commercialRealEstateAmount: amountToBorrow,
  "details.commercialRealEstateAmount": `Goals: Real Estate | ${amountToBorrow}`,
  commercialRealEstateTiming: loanTiming,
  "commercialRealEstateTiming.1": loanTimingOptions.now,
  "commercialRealEstateTiming.3": loanTimingOptions.three,
  "commercialRealEstateTiming.6": loanTimingOptions.six,
  "commercialRealEstateTiming.9": loanTimingOptions.nine,
  "commercialRealEstateTiming.12": loanTimingOptions.twelve,
  "details.commercialRealEstateTiming": `Goals: Real Estate | ${loanTiming}`,
  commercialRealEstateAccess: "When will you access your money?",
  "commercialRealEstateAccess.upFront": upFront,
  "commercialRealEstateAccess.overTime": overTime,
  "details.commercialRealEstateAccess": `Goals: Real Estate | ${loanAccess}`,
  commercialRealEstateWantsToBorrow: "Do you wish to borrow?",
  "commercialRealEstateWantsToBorrow.true": yes,
  "commercialRealEstateWantsToBorrow.false": no,
  "details.commercialRealEstateWantsToBorrow": `Goals: Real Estate | ${wantsToBorrow}`,

  "inventoryWorkingCapital.cardBuilder.title": "Working Capital",
  "inventoryWorkingCapital.cardBuilder.body":
    '<i class="bmo-icon personal-wallet"></i>',
  inventoryWorkingCapitalAmount: amountToBorrow,
  "details.inventoryWorkingCapitalAmount": `Goals: Working Capital | ${amountToBorrow}`,
  inventoryWorkingCapitalTiming: loanTiming,
  "inventoryWorkingCapitalTiming.1": loanTimingOptions.now,
  "inventoryWorkingCapitalTiming.3": loanTimingOptions.three,
  "inventoryWorkingCapitalTiming.6": loanTimingOptions.six,
  "inventoryWorkingCapitalTiming.9": loanTimingOptions.nine,
  "inventoryWorkingCapitalTiming.12": loanTimingOptions.twelve,
  "details.inventoryWorkingCapitalTiming": `Goals: Working Capital | ${loanTiming}`,
  inventoryWorkingCapitalAccess: "When will you access your money?",
  "inventoryWorkingCapitalAccess.upFront": upFront,
  "inventoryWorkingCapitalAccess.overTime": overTime,
  "details.inventoryWorkingCapitalAccess": `Goals: Working Capital | ${loanAccess}`,
  inventoryWorkingCapitalWantsToBorrow: "Do you wish to borrow?",
  "inventoryWorkingCapitalWantsToBorrow.true": yes,
  "inventoryWorkingCapitalWantsToBorrow.false": no,
  "details.inventoryWorkingCapitalWantsToBorrow": `Goals: Working Capital | ${wantsToBorrow}`,

  "acquisitionLoan.cardBuilder.title": "Business / Office Equipment",
  "acquisitionLoan.cardBuilder.body":
    '<i class="bmo-icon personal-wallet"></i>',
  acquisitionLoanAmount: amountToBorrow,
  "details.acquisitionLoanAmount": `Goals: Business / Office Equipment | ${amountToBorrow}`,
  acquisitionLoanTiming: loanTiming,
  "acquisitionLoanTiming.1": loanTimingOptions.now,
  "acquisitionLoanTiming.3": loanTimingOptions.three,
  "acquisitionLoanTiming.6": loanTimingOptions.six,
  "acquisitionLoanTiming.9": loanTimingOptions.nine,
  "acquisitionLoanTiming.12": loanTimingOptions.twelve,
  "details.acquisitionLoanTiming": `Goals: Business / Office Equipment | ${loanTiming}`,
  acquisitionLoanAccess: "When will you access your money?",
  "acquisitionLoanAccess.upFront": upFront,
  "acquisitionLoanAccess.overTime": overTime,
  "details.acquisitionLoanAccess": `Goals: Business / Office Equipment | ${loanAccess}`,
  acquisitionLoanWantsToBorrow: "Do you wish to borrow?",
  "acquisitionLoanWantsToBorrow.true": yes,
  "acquisitionLoanWantsToBorrow.false": no,
  "details.acquisitionLoanWantsToBorrow": `Goals: Business / Office Equipment | ${wantsToBorrow}`,

  /**
   * ============================
   * PRODUCT MESSAGES
   * ============================
   */

  "1000.name": "Basic Business Checking",
  "1000.description": "Perfect for the most micro and small businesses...",

  "1001.name": "Basic Business Savings",
  "1001.description": "Earn interest while maintaining in a low...",

  "1002.name": "Business Credit Card",
  "1002.description": "Gain a convenient purchasing method combined...",

  "1003.name": "Business Bill Pay",
  "1003.description":
    "American National Bank of Texas knows that small businesses...",

  "checking.name": "Checking",
  "checking.description":
    "<p>Basic Business Checking</p><span>Perfect for the most micro and small businesses. This account also includes Online Banking, a Business Debit Card, and E-Statements.</span>",

  "saving.name": "Saving and Investment",
  "saving.description":
    "<p>Basic Business Savings</p><span>Earn interest while maintaining in a low moderate balance.</span>",

  "creditCards.name": "Credit Cards",
  "creditCards.description":
    "<p>Business Credit Card</p><div>Gain a convenient purchasing method combined with the flexibility to set individual spending limits for each authorized employee as well as detailed online reports, flex miles, travel rewards and these peace of mind that comes with the security, realiability, conviencec and worldwide acceptance of the VISA brand.</div>",

  "treasury.name": "Treasury",
  "treasury.description":
    "<p>Business Bill Pay</p><div>American national Bank of Texas knows that small business depend on speed, efficiency and accessibility to run your business well. Business Bill Pay in an online solution designed specifically for small business to pay bills online, and delegate tasks and set permission controls.</div><p>Merchant Services</p><div>With a merchant account from American National Bank of Texas you have access to innovate electronic payment solutions that can help you satisfy your existing customers and attract new business</div><p>Direct Deposit</p><div>With ACH Services you not only save time and money by eliminating the need and expense of processing and distributing paper checks, you also mantain control of your available funds until you decide payment is to be made.</div>",

  "insurance.name": "Business Insurance",
  "insurance.description":
    "<p>Commercial Property, Equipment, Business Interruption</p><div>Comprehensive coverage options to meet the needs of specific industry segments.</div><p>Commercial Auto</p><div>Commercial vehicles including company-owned private passenger, trucks of all sizes, local and long-haul trucking and passenger</div><p>Worker's Compensations & Non-Subscribers Program</p><div>Workers Compensation for locations in Texas and across the country; Non-Subscriber Accident and Employer's Indemnity programs.</div>",

  // Real from Guides
  // 400's
  "438.name": "High Performance Checking",

  "439.name": "50+ Free Interest Checking",

  "440.name": "Direct Free Interest Checking",

  "441.name": "Simply Free Checking",
  "441.description": "Consumer Checking",

  "442.name": "Star Investment Savings",
  "442.description":
    "A savings account for individuals who maintain a high balance.  Minimum daily balances $25,000 or $50,000 average monthly.  Link your savings to your checking account for planned or unexpected events",
  "442.url": "http://www.anbtx.com/personal-banking-solutions/savings",

  "443.name": "Preferred Investment Savings",
  "443.description":
    "A savings account for individuals who maintain a medium to high balance.  Minimum daily balance of $2,500 or $5,000 average monthly.  Link your savings to your checking account for planned or unexpected events.",
  "443.url": "http://www.anbtx.com/personal-banking-solutions/savings",

  "444.name": "Primary Savings",
  "444.description":
    "A savings account for individuals who maintain a low to moderate balance.  Minimum daily balance of $200.  Link your savings to your checking account for planned or unexpected events.",
  "444.url": "http://www.anbtx.com/personal-banking-solutions/savings",

  "445.name": "Minor Savings",

  "446.name": "Minor Savings (under 18 years of age)",

  "447.name": "FDIC-insured CDs adn IRAs",
  "447.description":
    "Accounts that help you maximize your savings when you don't need immediate access to your funds. IRAs help you avoid income taxes while savings for retirement.  CDs provide higher interest rates that savings and are geared toward your specific timeframe.",

  "448.name": "Health Savings Account",

  "449.name": "Personal Loans",

  "450.name": "Home Equity Loan or Line of Credit",

  "451.name": "A Line of Credit",

  "452.name": "Trust Services",

  "453.name": "Investment & Estate Planning",

  "454.name": "Asset/Portfolio Management",

  "455.name": "Institutional Asset Management",

  "456.name": "Cash Management",

  "457.name": "Managed and Self-Directed IRAs",

  "458.name": "Retirement Planning",

  "459.name": "Fee Based Advisory Solutions",

  "460.name": "Investment Advisory Services",

  "461.name": "Brokerage Accounts",

  "462.name": "Annuities",

  "463.name": "Investment CDs",

  "464.name": "IRA CDs",

  "465.name": "Long-Term Care",

  "466.name": "Life Insurance",

  "467.name": "Alternative Investment Solutions",

  "468.name": "College Education Planning",

  "469.name": "Financial Planning",

  "470.name": "Homeowners Insurance",

  "471.name": "Personal Automobile Insurance",

  "472.name": "Individual Life Insurance",

  "497.name": "Simply Free Checking (under 18 years of age)",
  "497.description": "Minor Checking",

  // 500

  "502.name": "Business Analysis Checking",
  "502.url": "http://www.anbtx.com/business-banking/checking/business-analysis-checking",
  "502.description":
    "For businesses with more complex banking needs.  This account also includes Online Banking, a Business Debit Card, and account statements with check copies.",
  "502.features.count": 2,
  "502.features.1": "High number of transactions",
  "502.features.2": "Complex business needs",

  "503.name": "Business Interest Checking",
  "503.url": "https://app.loanspq.com/apply.aspx?lenderref=Anbtx082620&list=xast",
  "503.description":
    "Perfect for qualifying sole proprietorships. This account also includes Online Banking, a Business Debit Card, and account statements and check copies.",
  "503.features.count": 3,
  "503.features.1": "Moderate transaction level",
  "503.features.2": "No need for Treasury Products",
  "503.features.3": "You are a Sole Proprietor",

  "504.name": "Business Savings",

  "505.name": "Business Preferred Investment",
  "505.url": "http://www.anbtx.com/business-banking/savings",
  "505.description":
    "Perfect for businesses that maintain medium to high balances.",
  "505.features.count": 2,
  "505.features.1": "Earn Interest",
  "505.features.2": "You maintain a moderate balance",

  "506.name": "Business Star Investment",
  "506.url": "http://www.anbtx.com/business-banking/savings",
  "506.description": "Earn interest on your business's high balance.",
  "506.features.count": 2,
  "506.features.1": "Earn a higher level of interest",
  "506.features.2": "You maintain a high balance",

  "507.name": "Auto Sweep",

  "508.name": "Group Medical/Dental Insurance",

  "509.name":
    "Business Owners Package - Property, General Liability, Equipment",

  "510.name": "Business Auto",

  "511.name": "Worker's Compensation",

  "512.name": "Professional Liability",

  "513.name": "Key-man Insurance",

  "515.name": "Remote Deposit",

  "516.name": "ACH Direct Deposit for Payroll",
  "516.url":
    "http://www.anbtx.com/business-banking/business-digital-services/cash-management-services/ach",
  "516.description":
    "With ACH services you not only save time and money by eliminating the need and expense of processing and distributing paper checks, you also maintain control of your available funds until you decide payment is to be made.",
  "516.features.count": 2,
  "516.features.1": "Pay employees electronically",
  "516.features.2": "Simplify cash flow",

  "517.name": "Payroll Cards",

  "518.name": "ACH Cash Disbursements",

  "519.name": "Pre-Authorized Electronic Payments (ACH Collections)",

  "520.name": "Business Platinum Investment",
  "520.url": "http://www.anbtx.com/business-banking/savings",
  "520.description": "Perfect for businesses that maintain high balances.",
  "520.features.count": 2,
  "520.features.1": "Earn interest",
  "520.features.2": "You maintain a high balance",

  "521.name": "ACH Cash Concentration",

  "522.name": "Online Wire Transfers",
  "522.url":
    "http://www.anbtx.com/business-banking/business-digital-services/cash-management-services/wires",
  "522.description":
    "Electronically transfer funds on a same-day basis to your customers and vendors quickly and efficiently.",
  "522.features.count": 2,
  "522.features.1": "Transfer money to others with ease",
  "522.features.2": "Send money when you choose",

  "523.name": "Merchant Services",

  "524.name": "ACH Debit Block",

  "525.name": "Positive Pay",

  "526.name": "Account Reconciliation Service",

  "527.name": "Zero Balance Account Service",

  "528.name": "Business Credit Card",
  "528.url":
    "http://www.anbtx.com/business-banking/credit-cards",
  "528.description":
    "Gain a convenient purchasing method combined with the flexibility to set individual spending limits for each authorized employee as well as detailed online reports, flex miles, travel rewards and the peace of mind that comes with the security, reliability, convenience and worldwide acceptance of the VISA brand.",
  "528.features.count": 3,
  "528.features.1": "Ease and convenience of payments",
  "528.features.2": "Monthly record for purchase tracking",
  "528.features.3": "Great way to separate business and personal purchases",

  "529.name": "Business Loans and Lines of Credit",
  "529.url": "http://www.anbtx.com/business-banking/loans-loc",
  "529.description":
    "When your business needs financing solutions to grow, you can work with our experienced and committed commercial lenders to utilize our competitive fixed and flexible rates.",
  "529.features.count": 2,
  "529.features.1": "Source of growth for your established business",
  "529.features.2": "Competitive rates",

  "530.name": "Commercial Loan",
  "530.url": "http://www.anbtx.com/business-banking/commercial-lending",
  "530.description":
    "Our commercial Real Estate Lending Group has significant lending and marketing expertise when it comes to finding the best solution for you.",
  "530.features.count": 2,
  "530.features.1":
    "Our experts will help you find the best option for your needs",
  "530.features.2": "Competitve rate for your biz growth",

  "531.name": "Retirement Plan Operations Oversight and Management",

  "532.name": "Retirement Plan Consulting and Design",

  "534.name": "Discretionary Trustee Services",
  "534.url": "http://www.anbtx.com/wealth-management/trust-estate-planning/trust-iras/trustee-services",
  "534.description":
    "We have a comprehensive range of Wealth Management services to help maximize your assets while minimizing the demands on your time.",
  "534.features.count": 2,
  "534.features.1":
    "Experts to reduce the burden of managing your retirement plans",
  "534.features.2": "Time saving",

  "535.name": "Corporate Asset Management",
  "535.url":
    "http://www.anbtx.com/wealth-management/planning-investing-solutions/business-wealth-management",
  "535.description":
    "ANBTX will build long-term, mutually profitable relationships by excelling in understanding your needs and expectations to deliver superior value.",
  "535.features.count": 2,
  "535.features.1": "Make your cash work for you",
  "535.features.2":
    "Our experts work with you to create the best plan for your business",

  "536.name": "Personal Wealth Management",
  "536.url": "http://www.anbtx.com/wealth-management/planning-investing-solutions/investment-advisory",
  "536.description":
    "Our professional investment management provides financial guidance, advice and personalized service as we structure a portfolio suited for your objectives and risk tolerance.",
  "536.features.count": 2,
  "536.features.1": "Planning and investment strategies tailored to your specific needs and goals",
  "536.features.2": "Personalized short and long-term plans",

  "537.name": "Estate Planning",
  "537.url": "http://www.anbtx.com/wealth-management/trust-estate-planning/estate-administration-services",
  "537.features.count": 2,
  "537.features.1": "Our experts will guide you through the process",
  "537.features.2": "Create the plan that is best for you",

  "538.name": "Corporate Trust",
  "538.url": "http://www.anbtx.com/wealth-management/trust-estate-planning/corporate-trust-accounts",
  "538.description":
    "We understand the complexities and challenges facing local cities, schools and counties as well as local corporations and are prepared to assist you in both your registered and unregistered bond issues.",
  "538.features.count": 2,
  "538.features.1": "Our experts understand public administration",
  "538.features.2": "Make your cash work",

  "539.name": "Your K-Plan",
  "539.url": "http://www.anbtx.com/wealth-management/planning-investing-solutions/company-retirement-plans",
  "539.description":
    "Adopt a successful retirement plan for yourself and your employees without the added cost and difficulty of an independent plan.",
  "539.features.count": 2,
  "539.features.1": "Easy way to set up your company's 401K",
  "539.features.2": "Specifically designed for small businesses",

  "541.name": "Business Exit Plan Strategy",
  "541.url": "http://www.anbtx.com/wealth-management/trust-estate-planning/business-exit-plans",
  "541.description":
    "We can help construct a comprehensive business exit plan for you to use as a road map.",
  "541.features.count": 2,
  "541.features.1": "You desire to plan for this important transition",
  "541.features.2": "Our experts walk you through the step-by-step process",

  "542.name": "CD-Rom",

  "550.name": "Nonprofit Business Analysis Checking",
  "550.url": "http://www.anbtx.com/business-banking/checking/non-profit-business-checking ",
  "550.description": "For businesses with more complex banking needs.  This account also includes Online Banking, a Business Debit Card, and account statements with check copies.",
  "550.features.count": 2,
  "550.features.1": "High number of transactions",
  "550.features.2": "Complex business needs",

  "551.name": "Nonprofit Business Interest Checking",
  "551.url": "http://www.anbtx.com/business-banking/checking/non-profit-business-checking",
  "551.description": "Perfect for most micro and small businesses.   This account also includes Online Banking, a Business Debit Card, and E-Statements.",
  "551.features.count": 3,
  "551.features.1": "Moderate transaction level",
  "551.features.2": "No need for Treasury products",
  "551.features.2": "Your business is a Nonprofit",

  "552.name": "Nonprofit Basic Business Checking",
  "552.url": "http://www.anbtx.com/business-banking/checking/non-profit-business-checking",
  "552.description": "Perfect for qualifying not-for-profit organizations.   This account also includes Online Banking, a Business Debit Card, and account statements and check copies.",
  "552.features.count": 3,
  "552.features.1": "Lower transaction level",
  "552.features.2": "Low number of transactions",
  "552.features.2": "Lower balances",

  "560.name": "Nonprofit Business Analysis Checking",
  "560.applyURL": "https://app.loanspq.com/apply.aspx?lenderref=Anbtx082620&list=xast",
  "560.description": "For businesses with more complex banking needs. This account also includes Online Banking, a Business Debit Card, and account statements with check copies.",
  "560.features.count": 2,
  "560.features.1": "High number of transactions",
  "560.features.2": "Complex business needs",

  "561.name": "Nonprofit Business Interest Checking",
  "561.applyURL": "https://app.loanspq.com/apply.aspx?lenderref=Anbtx082620&list=xast",
  "561.description": "Perfect for qualifying not-for-profit organizations. This account also includes Online Banking, a Business Debit Card, and account statements and check copies.",
  "561.features.count": 3,
  "561.features.1": "Moderate transaction level",
  "561.features.2": "No need for Treasury products",
  "561.features.3": "Your business is a Nonprofit",

  "562.name": "Nonprofit Basic Business Checking",
  "562.applyURL": "https://app.loanspq.com/apply.aspx?lenderref=Anbtx082620&list=1bst",
  "562.description": "Perfect for most micro and small businesses. This account also includes Online Banking, a Business Debit Card, and E-Statements.",
  "562.features.count": 3,
  "562.features.1": "Lower transaction level",
  "562.features.2": "Low number of transactions",
  "562.features.3": "Lower balances",

  "563.name": "Business Analysis Checking",
  "563.applyURL": "https://app.loanspq.com/apply.aspx?lenderref=Anbtx082620&list=xast",
  "563.description": "For businesses with more complex banking needs. This account also includes Online Banking, a Business Debit Card, and account statements with check copies. ",
  "563.features.count": 2,
  "563.features.1": "High number of transactions",
  "563.features.2": "Complex business needs",

  "564.name": "Basic Business Checking",
  "564.applyURL": "https://app.loanspq.com/apply.aspx?lenderref=Anbtx082620&list=1bst",
  "564.description": "Perfect for most micro and small businesses. This account also includes Online Banking, a Business Debit Card, and E-Statements.",
  "564.features.count": 3,
  "564.features.1": "Lower transaction level",
  "564.features.2": "Low number of transactions",
  "564.features.3": "Lower balances",

  "1123.name": "Simply Free Checking",
  "1123.description": "Business Checking",

  // 1200

  "1234.name": "Direct Plus Checking",
  "1234.description":
    "A traditional account that rewards customers with no monthly service charge for being 55+ or using monthly direct deposit.  Choose eStatements to waive the fee for paper statements.",
  "1234.url": "http://www.anbtx.com/personal-banking-solutions/checking/directplus-checking",

  "1235.name": "Premium Checking",
  "1235.description":
    "An ideal account which earns interest on daily collected balances of $5,000 or more.  Avoid a monthly service charge when you maintain a minimum daily balance of $1,500 or a $15,000 average ledger balance in combined accounts",
  "1235.url": "http://www.anbtx.com/personal-banking-solutions/checking/premium-checking",

  "1236.name": "Free eChecking",
  "1236.description":
    "A simple account with no monthly service charge and the convenience and security of eStatements.",
  "1236.url": "http://www.anbtx.com/personal-banking-solutions/checking/free-echecking",

  "1237.name": "MyChoice Checking",
  "1237.description":
    "A traditional account with one low monthly service charge available for customers who would like to receive paper statements.",
  "1237.url": "http://www.anbtx.com/personal-banking-solutions/checking/my-choice-checking",

  // 1811400

  "1811408.name": "Basic Business Checking",
  "1811408.url": "http://www.anbtx.com/business-banking/checking/basic-business-checking",
  "1811408.description":
    "Perfect for most micro and small businesses. This account also includes Online Banking, a Business Debit Card, and E-Statements.",
  "1811408.features.count": 3,
  "1811408.features.1": "Lower transaction level",
  "1811408.features.2": "Low number of transactions",
  "1811408.features.3": "Lower balances",

  "1811409.name": "Basic Business Savings",
  "1811409.url": "http://www.anbtx.com/business-banking/savings",
  "1811409.description":
    "Earn interest while maintaining a low to moderate balance.",
  "1811409.features.count": 2,
  "1811409.features.1": "Earn Interest",
  "1811409.features.2": "Low balance requirement",

  "1811509.name": "Basic Business Savings",
  "1811509.applyURL": "https://app.loanspq.com/apply.aspx?lenderref=Anbtx082620&list=1bst",
  "1811509.description":
    "Earn interest while maintaining a low to moderate balance.",
  "1811509.features.count": 2,
  "1811509.features.1": "Earn Interest",
  "1811509.features.2": "Low balance requirement",

  "1811410.name": "Business Bill Pay",
  "1811410.url":
    "https://www.anbtx.com/business-banking/business-digital-services/cash-management-services/online-mobile-banking",
  "1811410.description":
    "American National Bank of Texas knows that small businesses depend on speed, efficiency and accessibility to run your business well.  Business Bill Pay in an online solution designed specifically for small business to pay bills online, and delegate tasks and set permission controls.",
  "1811410.features.count": 2,
  "1811410.features.1": "The most efficient way to pay bills and see balances",
  "1811410.features.2": "Security for multiple employee access",

  "1811411.name": "Merchant Services",
  "1811411.url":
    "http://www.anbtx.com/business-banking/business-digital-services/cash-management-services/merchant-processing-services",
  "1811411.description":
    "With a merchant account from American National Bank of Texas, you have access to innovate electronic payment solutions that can help you satisfy your existing customers and attract new business.",
  "1811411.features.count": 3,
  "1811411.features.1": "Improve your cash flow",
  "1811411.features.2":
    "Provide a convenient way for your customers to pay you",
  "1811411.features.3": "Speed your collections",

  "1811412.name": "Remote Deposit",
  "1811412.url":
    "http://www.anbtx.com/business-banking/business-digital-services/cash-management-services/remote-deposit",
  "1811412.description":
    "Allows you to electronically deposit checks into your American National Bank of Texas account directly from your desktop",
  "1811412.features.count": 2,
  "1811412.features.1": "You receive a lot of checks",
  "1811412.features.2": "Speed up cash inflows",

  "1811416.name": "Check Positive Pay",
  "1811416.url":
    "http://www.anbtx.com/business-banking/business-digital-services/treasury-management-services/fraud-mitigation",
  "1811416.description":
    "Check Positive Pay assist in the fight against losses due to check fraud by performing a daily reconcilement of your company's issued checks against checks presented for payment.",
  "1811416.features.count": 1,
  "1811416.features.1": "Automatic daily reconciliation of valid checks",

  "1811417.name": "ACH Positive Pay",
  "1811417.url":
    "http://www.anbtx.com/business-banking/business-digital-services/treasury-management-services/fraud-mitigation",
  "1811417.description":
    "Tailor your protection level against unauthorized ACH Debits.",
  "1811417.features.count": 1,
  "1811417.features.1": "Automatic reconciliation of valid ACH withdrawals",

  "1811420.name": "Payroll Services",
  "1811420.url": "http://www.anbtx.com/business-banking/business-digital-services/cash-management-services/payroll-services",
  "1811420.description":
    "With Paychex Payroll Services from American National Bank of Texas, you have access to a comprehensive suite of payroll, payroll taxes, and employee pay services.  Confidential cost-effective payroll; 1 administration eliminates the tedious chore of payroll - before and after pay day.",
  "1811420.features.count": 2,
  "1811420.features.1": "Remove administrative burden",
  "1811420.features.2": "Automatically pay taxes",
};

